module.exports = __webpack_public_path__ + "media/categories/1014-01fba077.svg";